import { useMemo, useCallback } from 'react';
import flattenDeep from 'lodash/flattenDeep';
import { useLocation, useNavigate } from 'react-router-dom';
import { StepPropsType, useMenuItems } from './useMenuItems';
import { ProjectDto } from '@/core';

function constructorMenuTabs(items: StepPropsType[]) {
  const tabs: string[] = flattenDeep(
    items.map((x) => [x!.key, (x as any).children?.map((child: any) => child.key) ?? []]),
  );

  return tabs;
}

export function useNavigateConstructorTabs(projectData: ProjectDto) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const menuItems = useMenuItems(projectData);
  const currentRoute = pathname.split('/');
  const constructorTabs = constructorMenuTabs(menuItems);

  const currentTab = currentRoute.splice(-1, 1).join('');
  const currentTabIndex = useMemo(() => constructorTabs.indexOf(currentTab!), [constructorTabs, currentTab]);

  const nextTab = constructorTabs.at(currentTabIndex + 1);
  const previousTab = constructorTabs.at(currentTabIndex - 1);

  const previousTabUrl = [...currentRoute, previousTab].join('/');
  const nextTabUrl = [...currentRoute, nextTab].join('/');

  const navigateToNextTab = useCallback(() => {
    navigate(nextTabUrl);
  }, [navigate, nextTabUrl]);
  const navigateToPreviousTab = useCallback(() => {
    navigate(previousTabUrl);
  }, [navigate, previousTabUrl]);

  return useMemo(
    () => ({
      navigateToNextTab,
      navigateToPreviousTab,
      currentTabIndex,
    }),
    [navigateToNextTab, navigateToPreviousTab, currentTabIndex],
  );
}
